module.exports = __webpack_public_path__ + "static/media/select-house-element.bb767c19.gif";